/**
* Any hardcode settings and namings put here.
* It is applied in global.
*/
export class Consts {
    /** Naming for current login user's token name in local storage. */
    public readonly currentUser = 'currentUser';
    public readonly appContext = 'AppContext';
}

/**
 * Global const contains all hardcode values and namings.
 */
export const APP_CONSTS = new Consts();
